/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef, useState} from 'react'
import ApexCharts, {ApexOptions} from 'apexcharts'
import {useIntl} from 'react-intl'
import {useThemeMode} from '../../../_metronic/partials'
import {KTIcon} from '../../../_metronic/helpers'
import {getCSSVariableValue} from '../../../_metronic/assets/ts/_utils'
import ContentModule from '../../modules/profile/Dtos/ContentModule'
import {
  CourseModuleModel,
  GetCourseOutput,
  ResponseModel,
} from '../../../Adaptor/TUBSIS/controllers/Courses/models/getCourseModels'
import moment from 'moment'
import {useCourseContext} from '../../modules/profile/contexts/CourseContext'
import {Question} from '../../../Adaptor/TUBSIS/controllers/Tests/models/testModels'

type Props = {
  className: string
  chartHeight: string
  title?: string
  titleDesc?: string
  desc?: string
  module?: CourseModuleModel
  moduleId?: number
  onClick?: () => void
}

const ModuleWidget: React.FC<Props> = ({
  className,
  chartHeight,
  title,
  titleDesc,
  desc,
  module,
  moduleId,
  onClick,
}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const {mode} = useThemeMode()

  /* let totalAchievementCount = module?.contents ? module?.contents?.length : 0
  let doneAchievementCount = module?.contents
    ? module?.contents?.filter((x) => x.isCompleted).length
    : 0*/
  let percent = module ? module.moduleCompletionPercent : 0
  /*totalAchievementCount !== 0 ? (100 * doneAchievementCount) / totalAchievementCount : 0*/
  let chartColor =
    module && module.isEnabled
      ? percent < 26
        ? 'danger'
        : percent < 51
        ? 'warning'
        : percent < 91
        ? 'success'
        : module.isCompleted
        ? 'primary'
        : 'info'
      : 'secondary'
  let textColor =
    module && module.isEnabled
      ? percent < 26
        ? 'white'
        : percent < 51
        ? 'dark'
        : percent < 91
        ? 'white'
        : module.isCompleted
        ? 'white'
        : 'white'
      : 'white'

  const refreshChart = () => {
    if (!chartRef.current) {
      return
    }
    const chart = new ApexCharts(chartRef.current, chartOptions(chartColor, chartHeight, percent))
    if (chart) {
      chart.render()
    }

    return chart
  }
  let intl = useIntl()
  useEffect(() => {
    const chart = refreshChart()

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartRef, mode, percent, module])
  /*
  const responseGroup = module?.responses.map(x => x.question)
    .reduce(function(a:Question[], b){ return a.concat(b); }, [])
    .reduce((catsSoFar, { tagCode, id }) => {
    if (!catsSoFar[tagCode]) catsSoFar[tagCode] = [];
    catsSoFar[tagCode].push(id);
    return catsSoFar;
  }, {});*/
  const groupedResponses: {[key: number]: ResponseModel[]} = {}
  if (!onClick) {
    module?.responses.forEach((response) => {
      const tag = response.question.tag
      if (!groupedResponses[tag]) {
        groupedResponses[tag] = []
      }
      groupedResponses[tag].push(response)
    })
  }
  const ResponseAccordion: React.FC<{
    tag: number
    responses: ResponseModel[]
    activeItem: any
    toggleAccordion: (tag: number) => void
  }> = ({tag, responses, activeItem, toggleAccordion}) => {
    const getTitle = (code: number) => {
      switch (code) {
        case 15001:
          return 'HAPA Testi'
        case 15002:
          return 'FNBT Testi'
        case 15003:
          return 'WEMİOÖ Testi'
        // case 15005:
        //   return 'Sigara İçme Arzusu Ölçeği'
      }
    }

    return (
      <div key={tag}>
        <div
          className='flex justify-between items-center bg-gray-200 p-4 cursor-pointer'
          onClick={() => toggleAccordion(tag)}
        >
          <div>
            {getTitle(tag) +
              ` (${responses
                .map((x) => (x.choice ? x.choice.value : 0))
                .reduce((sum, num) => sum + num, 0)} Puan)`}
          </div>
        </div>
        {tag === activeItem && (
          <div className='bg-gray-50 p-4'>
            {responses.map((res) => {
              return (
                <div className='m-2'>
                  <div className='fw-bold'>{res.question.text}</div>
                  <div className='ml-3 fw-bold text-muted fs-9'>
                    {!res.choiceId && res.responseText == '-1'
                      ? 'Kararsızım'
                      : (res.question.answerPrefix ? res.question.answerPrefix + ' ' : '') +
                        (res.choice ? res.choice.text : res.responseText) +
                        (res.question.answerSuffix ? ' ' + res.question.answerSuffix : '') +
                        (res.choice ? `(${res.choice.value} puan)` : '')}
                  </div>
                </div>
              )
            })}
          </div>
        )}
      </div>
      /*<div className='accordion'>
        <div className='accordion-header'>{`Tag: ${tag}`}</div>
        <div className='accordion-content'>
          <ul>
            {responses.map((response) => (
              <li key={response.id}>{response.responseText}</li>
            ))}
          </ul>
        </div>
      </div>*/
    )
  }

  const CourseResponseAccordion: React.FC<{
    groupedResponses: {[key: number]: ResponseModel[]}
  }> = ({groupedResponses}) => {
    const [activeItem, setActiveItem] = useState<number>(0)
    const toggleAccordion = (index: number) => {
      setActiveItem(index === activeItem ? 0 : index)
    }
    return (
      <div className='space-y-4'>
        {Object.keys(groupedResponses).map((tag) => (
          <ResponseAccordion
            key={parseInt(tag, 10)}
            tag={parseInt(tag, 10)}
            responses={groupedResponses[parseInt(tag, 10)]}
            activeItem={activeItem}
            toggleAccordion={toggleAccordion}
          />
        ))}
      </div>
    )
  }

  return (
    <div className={`card ${className}`}>
      {/* begin::Beader */}
      <div
        className={
          percent !== 100
            ? 'card-header border-0 py-5'
            : 'card-header border-0 py-5 ribbon ribbon-top ribbon-vertical'
        }
      >
        {module?.isCompleted && (
          <div className={'ribbon-label'}>
            <KTIcon iconName='award' className={'text-white bg-' + chartColor + ' fs-2x'} />
          </div>
        )}
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>{title}</span>
          <span className='text-muted fw-semibold fs-7'>{titleDesc}</span>
          <div className='fw-bold text-muted fs-9'>
            {!onClick &&
              module?.relatedTestCompletionDate &&
              'Ölçüm Trh. :' +
                moment(module?.relatedTestCompletionDate).format('DD MMMM YYYY HH:mm')}
          </div>
        </h3>
        {/* 
        <div className='card-toolbar'> */}
        {/* begin::Menu */}
        {/* <button
            type='button'
            className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
            data-kt-menu-trigger='click'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='top-end'
          >
            <KTIcon iconName='category' className='fs-2' />
          </button> */}
        {/* <Dropdown1 /> */}
        {/* end::Menu */}
        {/* </div> */}
      </div>
      {/* end::Header */}

      {/* begin::Body */}
      <div className='card-body d-flex flex-column'>
        <div className='flex-grow-1'>
          <>
            <div ref={chartRef} className='mixed-widget-4-chart'></div>
            {onClick && <p>{desc}</p>}
            {module?.contents &&
              module?.contents.map((item, index) => (
                <>
                  <div
                    key={item.id.toString()}
                    className='d-flex align-items-center mb-4 svg-icon-secondary'
                  >
                    <div>
                      <KTIcon
                        iconName={item.isCompleted ? 'shield-tick' : 'abstract-13'}
                        className={`fs-2x col-2 ${item.isCompleted ? 'text-' + chartColor : ''}`}
                      />
                    </div>
                    <div className='col-8'>{item.title}</div>
                    {!onClick && item?.completionDate && (
                      <div className='col-3 fw-bold text-muted fs-9'>
                        {moment(item?.completionDate).format('DD MMMM YYYY HH:mm')}
                      </div>
                    )}
                  </div>
                </>
              ))}

            <br />
          </>
        </div>

        <div className='pt-5'>
          <>
            {/* <p className='text-center fs-6 pb-5 '>
            <span className='badge badge-light-danger fs-8'>Notes:</span>&nbsp; Current sprint
            requires stakeholders
            <br />
            to approve newly amended policies
          </p> */}

            {percent != null && onClick && (
              <button
                className={`btn btn-${chartColor} w-100 py-3`}
                onClick={onClick}
                disabled={!module || !module.isEnabled}
              >
                {module && module.isEnabled
                  ? percent === 0
                    ? intl.formatMessage({id: 'CONTENT.LETSGO'})
                    : percent !== 100
                    ? intl.formatMessage({id: 'CONTENT.TOBECONTINUED'})
                    : !module.isCompleted &&
                      !module.contents.some((x) => {
                        if (!x.isCompleted) return x
                      })
                    ? intl.formatMessage({id: 'CONTENT.COMPLETETEST'})
                    : intl.formatMessage({id: 'CONTENT.CONGRATZ'})
                  : module && module.activationDate
                  ? moment(module.activationDate).format('DD.MM.YYYY HH:mm') +
                    ' ' +
                    intl.formatMessage({id: 'CONTENT.ACTIVATIONDATE'})
                  : intl.formatMessage({id: 'CONTENT.NOTENABLED'})}
              </button>
            )}
          </>
        </div>
        {!onClick && <CourseResponseAccordion groupedResponses={groupedResponses} />}
      </div>
      {/* end::Body */}
    </div>
  )
}

const chartOptions = (chartColor: string, chartHeight: string, percent: number): ApexOptions => {
  const baseColor = getCSSVariableValue('--bs-' + chartColor)
  const lightColor = getCSSVariableValue('--bs-' + chartColor + '-light')
  const labelColor = getCSSVariableValue('--bs-gray-700')

  return {
    series: [parseFloat(percent.toFixed(2))],
    chart: {
      fontFamily: 'inherit',
      height: chartHeight,
      type: 'radialBar',
    },
    plotOptions: {
      radialBar: {
        hollow: {
          margin: 0,
          size: '65%',
        },
        dataLabels: {
          name: {
            show: false,
            fontWeight: '700',
          },
          value: {
            color: labelColor,
            fontSize: '30px',
            fontWeight: '700',
            offsetY: 12,
            show: true,
            formatter: function (val) {
              return val + '%'
            },
          },
        },
        track: {
          background: lightColor,
          strokeWidth: '100%',
        },
      },
    },
    colors: [baseColor],
    stroke: {
      lineCap: 'round',
    },
    labels: ['Progress'],
  }
}

export {ModuleWidget}
